import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { HeaderComponent } from './header.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'src/app/common/modules/shared.module';
import { HeaderRoutingModule } from './header-routing.module';

@NgModule({
    imports: [
        CommonModule,
        HeaderRoutingModule,
        IonicModule,
        RouterModule,
        SharedModule
    ],
    declarations: [
        HeaderComponent
    ],
    exports: [HeaderComponent]
})

export class HeaderModule { }
